import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";

// Phase 2Z.aa - reusable locked-state card for plan-gated features.
//
// Pure presentation. Renders:
//   - a plan badge ("GROWTH" / "COMMAND")
//   - a clear title
//   - friendly body copy explaining what the feature does and what the
//     customer can do on their current plan
//   - two CTA buttons (primary upgrade + secondary "Open Roster")
//
// Customer wording should always be premium, never punitive.
export default function LockedFeatureCard({
  testid,
  badge,           // "GROWTH" | "COMMAND"
  title,
  body,
  primary,         // { label, to }
  secondary,       // { label, to }
}) {
  const badgeClass =
    badge === "COMMAND"
      ? "bg-[#FEF3C7] text-[#92400E]"
      : "bg-[#DBE7FE] text-[#1D4ED8]";
  return (
    <div
      data-testid={testid}
      className="max-w-2xl mx-auto my-12 rounded-2xl border border-slate-200 bg-white p-8 sm:p-10 shadow-sm"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-lg bg-slate-50 grid place-items-center">
          <Lock className="h-5 w-5 text-[#4B5773]" />
        </div>
        {badge && (
          <span
            data-testid={`${testid}-badge`}
            className={`text-[10px] uppercase tracking-widest font-semibold px-2 py-1 rounded-full ${badgeClass}`}
          >
            {badge} feature
          </span>
        )}
      </div>
      <h2
        data-testid={`${testid}-title`}
        className="font-display text-2xl sm:text-3xl text-[#0B1A36] leading-snug"
      >
        {title}
      </h2>
      <p
        data-testid={`${testid}-body`}
        className="text-base text-[#4B5773] mt-3 leading-relaxed"
      >
        {body}
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        {primary && (
          <Link
            to={primary.to}
            data-testid={`${testid}-primary`}
            className="inline-flex items-center px-4 py-2 rounded-md bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-sm font-semibold"
          >
            {primary.label}
            <ArrowRight className="h-4 w-4 ml-1.5" />
          </Link>
        )}
        {secondary && (
          <Link
            to={secondary.to}
            data-testid={`${testid}-secondary`}
            className="inline-flex items-center px-4 py-2 rounded-md border border-slate-200 bg-white text-[#0B1A36] text-sm font-medium hover:bg-slate-50"
          >
            {secondary.label}
          </Link>
        )}
      </div>
    </div>
  );
}
